export default {
  nav: {
    overview: "Overview",
    applications: "Applications",
    members: "Members",
    authors: "Author cabinet",
    works: "Verification",
    events: "Events",
    structure: "Structure",
  },
  overviewTitle: "Writers Union workspace",
  overviewHint: "Moderate applications, manage the registry and verify works.",
  applicationsEmpty: "No pending applications.",
  membersEmpty: "Registry is empty.",
  worksEmpty: "No works awaiting verification.",
  approve: "Approve",
  reject: "Reject",
  verify: "Verify",
  overview: {
    welcomeHint: "Membership applications, the member registry and authorship verification.",
    statsTitle: "Summary",
    applicationsTitle: "Applications",
    applicationsHint: "Candidates awaiting the union's decision.",
    worksTitle: "Verification",
    worksHint: "Works awaiting authorship confirmation.",
    membersTitle: "Member registry",
    membersHint: "Current members of the Writers Union.",
    pending: "Awaiting decision",
    total: "Total",
    servicesTitle: "Quick actions",
    services: {
      applications: { title: "Applications", desc: "Approve or reject candidates." },
      members: { title: "Registry", desc: "Members, card numbers and years joined." },
      authors: { title: "Author cabinet", desc: "Create a profile and issue a sign-in link." },
      works: { title: "Verification", desc: "Confirm authorship of works." },
    },
  },
  applications: {
    subtitle: "Candidates who applied to join the union.",
    columns: { name: "Candidate", region: "Region", submitted: "Submitted", actions: "Decision" },
    approveTitle: "Approve membership",
    approveMessage: "{{name}} will become a member of the Writers Union.",
    rejectTitle: "Reject application",
    rejectMessage: "{{name}} will see the rejection and your comment in their cabinet.",
    note: "Comment for the candidate",
  },
  members: {
    subtitle: "Current members of the Writers Union.",
    search: "Search by name, pen name or card number",
    clearSearch: "Clear search",
    notFound: "Nobody found. Change the query.",
    columns: { name: "Name", region: "Region", cardNo: "Card", joined: "Member since", status: "Status" },
  },
  works: {
    subtitle: "Portfolio works awaiting authorship confirmation.",
    columns: { title: "Work", year: "Year", isbn: "ISBN", author: "Author", added: "Added", actions: "Decision" },
    rejectTitle: "Reject work",
    rejectMessage: "“{{title}}” will not appear on the writer's public card.",
  },
  authors: {
    sections: { name: "Name", membership: "Membership" },
    title: "Author cabinet",
    hint: "The person joins the member registry immediately. They can sign in after opening the link.",
    lastName: "Last name",
    firstName: "First name",
    patronymic: "Patronymic",
    pseudonym: "Pen name",
    region: "Region",
    authorType: "Author type",
    cardNo: "Card number",
    joinedYear: "Year joined",
    submit: "Create cabinet",
    linkLabel: "Link for the author",
    linkHint: "Send it to the person. The link lasts 30 days and attaches the cabinet to their NBR login.",
    copy: "Copy",
    copied: "Link copied",
  },
  claim: {
    title: "Author cabinet",
    hint: "Attach the prepared profile to your login.",
    submit: "Attach",
    missing: "The link has no invitation code.",
    done: "Cabinet attached.",
  },
}
